<template>
    <div class="dashboard-container">
      <!-- 筛选条件区域 -->
      <el-card class="filter-container">
        <div class="filter-item">
          <el-date-picker
            v-model="dateRange"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="yyyy-MM-dd"
            :picker-options="pickerOptions">
          </el-date-picker>
          
          <el-select v-model="department" placeholder="科室选择" multiple style="width: 180px; margin-left: 10px">
            <el-option v-for="item in departmentOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
          
          <el-select v-model="patientType" placeholder="患者类型" multiple style="width: 180px; margin-left: 10px">
            <el-option v-for="item in patientTypeOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
          
          <el-select v-model="disease" placeholder="病种分类" multiple style="width: 180px; margin-left: 10px">
            <el-option v-for="item in diseaseOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
          
          <el-select v-model="doctor" placeholder="医生/个管师" style="width: 180px; margin-left: 10px">
            <el-option v-for="item in doctorOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
          
          <el-button type="primary" icon="el-icon-search" style="margin-left: 10px" @click="handleSearch">查询</el-button>
          <el-button type="success" icon="el-icon-refresh" style="margin-left: 10px" @click="handleRefresh">刷新</el-button>
        </div>
      </el-card>
      
      <!-- 数据总览区域 -->
      <div class="dashboard-panel">
        <el-row :gutter="20">
          <el-col :span="4" v-for="(item, index) in cardData" :key="index">
            <el-card class="data-card" shadow="hover">
              <div class="card-item">
                <div class="card-icon" :style="{backgroundColor: item.color}">
                  <i :class="item.icon"></i>
                </div>
                <div class="card-info">
                  <div class="card-title">{{ item.title }}</div>
                  <div class="card-count">{{ item.count }}</div>
                </div>
              </div>
            </el-card>
          </el-col>
        </el-row>
      </div>
      
      <!-- 图表展示区域 -->
      <div class="chart-container">
        <el-row :gutter="20">
          <el-col :span="12">
            <el-card class="box-card">
              <div slot="header" class="chart-header">
                <span>随访完成率趋势图</span>
              </div>
              <div class="chart" id="completionRateChart" style="height: 350px"></div>
            </el-card>
          </el-col>
          <el-col :span="12">
            <el-card class="box-card">
              <div slot="header" class="chart-header">
                <span>患者满意度分析</span>
              </div>
              <div class="chart" id="satisfactionChart" style="height: 350px"></div>
            </el-card>
          </el-col>
        </el-row>
        
        <el-row :gutter="20" style="margin-top: 20px">
          <el-col :span="12">
            <el-card class="box-card">
              <div slot="header" class="chart-header">
                <span>随访执行情况分析</span>
              </div>
              <div class="chart" id="executionChart" style="height: 350px"></div>
            </el-card>
          </el-col>
          <el-col :span="12">
            <el-card class="box-card">
              <div slot="header" class="chart-header">
                <span>随访渠道分布</span>
              </div>
              <div class="chart" id="channelChart" style="height: 350px"></div>
            </el-card>
          </el-col>
        </el-row>
      </div>
      
      <!-- 异常数据提醒 -->
      <el-card class="warning-container" v-if="warningData.length > 0">
        <div slot="header" class="warning-header">
          <span><i class="el-icon-warning" style="color: #E6A23C"></i> 异常数据提醒 ({{ warningData.length }}条未处理)</span>
        </div>
        <div v-for="(item, index) in warningData" :key="index" class="warning-item">
          <span class="warning-text">{{ index + 1 }}. {{ item.content }}</span>
          <span class="warning-actions">
            <el-button type="text" size="small" @click="handleWarning(item)">立即查看</el-button>
            <el-button type="text" size="small" @click="ignoreWarning(item)">忽略</el-button>
          </span>
        </div>
      </el-card>
      
      <!-- 随访数据表格 -->
      <el-card class="table-container">
        <div slot="header" class="table-header">
          <span>随访数据明细</span>
          <div class="right-btns">
            <el-button type="success" size="small" icon="el-icon-download" @click="exportToExcel">导出Excel</el-button>
            <el-button type="primary" size="small" icon="el-icon-document" @click="exportToPdf">导出PDF</el-button>
          </div>
        </div>
        
        <el-table
          :data="tableData"
          style="width: 100%"
          border
          row-key="id"
          :expand-row-keys="expandRowKeys"
          @expand-change="handleExpandChange">
          <el-table-column type="expand">
            <template slot-scope="props">
              <el-form label-position="left" inline class="expanded-row">
                <el-form-item label="随访详情">
                  <span>{{ props.row.detail }}</span>
                </el-form-item>
                <el-form-item label="检查单">
                  <el-link type="primary" @click="viewDocument(props.row)">查看检查单</el-link>
                </el-form-item>
                <el-form-item label="量表结果">
                  
                  <el-progress :percentage="props.row.scaleResult" :color="customColorMethod"></el-progress>
                </el-form-item>
              </el-form>
            </template>
          </el-table-column>
          <el-table-column prop="patientName" label="患者姓名" width="120"></el-table-column>
          <el-table-column prop="followUpType" label="随访类型" width="120"></el-table-column>
          <el-table-column prop="department" label="科室" width="120"></el-table-column>
          <el-table-column prop="doctor" label="随访医生" width="120"></el-table-column>
          <el-table-column prop="planDate" label="计划日期" width="120"></el-table-column>
          <el-table-column prop="actualDate" label="实际完成日期" width="120"></el-table-column>
          <el-table-column label="完成状态" width="100">
            <template slot-scope="scope">
              <el-tag :type="scope.row.status === '完成' ? 'success' : 'danger'">
                {{ scope.row.status }}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column label="患者满意度" width="150">
            <template slot-scope="scope">
              <el-rate
                v-model="scope.row.satisfaction"
                disabled
                show-score
                text-color="#ff9900">
              </el-rate>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="120">
            <template slot-scope="scope">
              <el-button type="text" size="small" @click="viewDetail(scope.row)">查看</el-button>
              <el-button type="text" size="small" @click="handleEdit(scope.row)">编辑</el-button>
            </template>
          </el-table-column>
        </el-table>
        
        <div class="pagination-container">
          <el-pagination
            background
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="currentPage"
            :page-sizes="[10, 20, 30, 50]"
            :page-size="pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total">
          </el-pagination>
        </div>
      </el-card>
    </div>
  </template>
  
  <script>
  import * as echarts from 'echarts'
  
  export default {
    name: 'DataReport',
    data() {
      return {
        // 筛选条件
        dateRange: ['2024-01-01', '2024-12-31'],
        department: [],
        patientType: [],
        disease: [],
        doctor: '',
        pickerOptions: {
          shortcuts: [{
            text: '最近一周',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
              picker.$emit('pick', [start, end])
            }
          }, {
            text: '最近一个月',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
              picker.$emit('pick', [start, end])
            }
          }, {
            text: '最近三个月',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
              picker.$emit('pick', [start, end])
            }
          }]
        },
        departmentOptions: [
          { value: '呼吸科', label: '呼吸科' },
          { value: '肿瘤科', label: '肿瘤科' },
          { value: '泌尿科', label: '泌尿科' },
          { value: '心内科', label: '心内科' },
          { value: '消化科', label: '消化科' }
        ],
        patientTypeOptions: [
          { value: '门诊患者', label: '门诊患者' },
          { value: '住院患者', label: '住院患者' },
          { value: '术后患者', label: '术后患者' }
        ],
        diseaseOptions: [
          { value: '肺癌', label: '肺癌' },
          { value: '前列腺癌', label: '前列腺癌' },
          { value: '高血压', label: '高血压' },
          { value: '糖尿病', label: '糖尿病' },
          { value: '冠心病', label: '冠心病' }
        ],
        doctorOptions: [
          { value: '', label: '全部' },
          { value: '张医生', label: '张医生' },
          { value: '李医生', label: '李医生' },
          { value: '王医生', label: '王医生' }
        ],
        
        // 指标卡数据
        cardData: [
          { title: '总随访患者数', count: '1280人', icon: 'el-icon-user-solid', color: '#409EFF' },
          { title: '随访计划总数', count: '356项', icon: 'el-icon-s-order', color: '#67C23A' },
          { title: '随访完成率', count: '93.5%', icon: 'el-icon-s-data', color: '#E6A23C' },
          { title: '患者满意度', count: '95.2%', icon: 'el-icon-star-on', color: '#F56C6C' },
          { title: '异常数据条数', count: '25条', icon: 'el-icon-warning', color: '#909399' },
          { title: '待随访患者', count: '42人', icon: 'el-icon-s-opportunity', color: '#9B59B6' }
        ],
        
        // 图表实例
        completionRateChart: null,
        satisfactionChart: null,
        executionChart: null,
        channelChart: null,
        
        // 异常数据
        warningData: [
          { id: 1, content: '患者"李XX"随访未完成，超过计划5天。', type: 'delay' },
          { id: 2, content: '患者"王XX"满意度评价为不满意。', type: 'satisfaction' },
          { id: 3, content: '患者"张XX"术后随访生命体征异常，需立即联系。', type: 'emergency' },
          { id: 4, content: '患者"赵XX"连续两次未按时服药，存在风险。', type: 'medication' },
          { id: 5, content: '患者"孙XX"术后康复进度低于预期20%。', type: 'recovery' }
        ],
        
        // 表格数据
        tableData: [],
        expandRowKeys: [],
        currentPage: 1,
        pageSize: 10,
        total: 100,
        
        // 模拟生成数据
        patientNames: ['许昊然', '苏雅婷', '林书辰', '程若曦', '郭子轩', '韩宇航', '江语涵', '沈思妍'],
        followUpTypes: ['术后随访', '定期随访', '复诊随访', '药物随访', '康复随访'],
        departments: ['呼吸科', '肿瘤科', '泌尿科', '心内科', '消化科'],
        doctors: ['张医生', '李医生', '王医生', '赵医生', '刘医生'],
        status: ['完成', '未完成']
      }
    },
    mounted() {
      this.generateTableData()
      this.$nextTick(() => {
        this.initCharts()
      })
    },
    methods: {
      // 筛选相关方法
      handleSearch() {
        this.$message.success('执行查询操作，筛选条件已应用')
        this.generateTableData()
        this.refreshCharts()
      },
      handleRefresh() {
        this.$message.success('数据已刷新')
        this.generateTableData()
        this.refreshCharts()
      },
      
      // 图表初始化方法
      initCharts() {
        this.initCompletionRateChart()
        this.initSatisfactionChart()
        this.initExecutionChart()
        this.initChannelChart()
        
        // 添加窗口大小变化时图表自动调整大小
        window.addEventListener('resize', this.resizeAllCharts)
      },
      
      // 随访完成率趋势图
      initCompletionRateChart() {
        this.completionRateChart = echarts.init(document.getElementById('completionRateChart'))
        const option = {
          tooltip: {
            trigger: 'axis'
          },
          legend: {
            data: ['计划完成率', '实际完成率']
          },
          grid: {
            left: '3%',
            right: '4%',
            bottom: '3%',
            containLabel: true
          },
          xAxis: {
            type: 'category',
            boundaryGap: false,
            data: ['1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月']
          },
          yAxis: {
            type: 'value',
            min: 80,
            max: 100,
            axisLabel: {
              formatter: '{value}%'
            }
          },
          series: [
            {
              name: '计划完成率',
              type: 'line',
              stack: '总量',
              data: [90, 92, 88, 94, 96, 95, 93, 94, 96, 95, 93, 97],
              areaStyle: {
                opacity: 0.3
              },
              symbol: 'circle',
              symbolSize: 8,
              itemStyle: {
                color: '#409EFF'
              }
            },
            {
              name: '实际完成率',
              type: 'line',
              stack: '总量',
              data: [88, 90, 85, 92, 94, 93, 91, 93, 95, 94, 92, 96],
              areaStyle: {
                opacity: 0.3
              },
              symbol: 'circle',
              symbolSize: 8,
              itemStyle: {
                color: '#67C23A'
              }
            }
          ]
        }
        this.completionRateChart.setOption(option)
      },
      
      // 患者满意度分析图
      initSatisfactionChart() {
        this.satisfactionChart = echarts.init(document.getElementById('satisfactionChart'))
        const option = {
          tooltip: {
            trigger: 'item',
            formatter: '{a} <br/>{b}: {c} ({d}%)'
          },
          legend: {
            orient: 'vertical',
            left: 10,
            data: ['非常满意', '满意', '一般', '不满意', '非常不满意']
          },
          series: [
            {
              name: '患者满意度',
              type: 'pie',
              radius: ['50%', '70%'],
              avoidLabelOverlap: false,
              label: {
                show: true,
                position: 'outside',
                formatter: '{b}: {d}%'
              },
              emphasis: {
                label: {
                  show: true,
                  fontSize: '16',
                  fontWeight: 'bold'
                }
              },
              labelLine: {
                show: true
              },
              data: [
                { value: 55, name: '非常满意' },
                { value: 40, name: '满意' },
                { value: 4, name: '一般' },
                { value: 1, name: '不满意' },
                { value: 0, name: '非常不满意' }
              ],
              color: ['#67C23A', '#409EFF', '#E6A23C', '#F56C6C', '#909399']
            }
          ]
        }
        this.satisfactionChart.setOption(option)
      },
      
      // 随访执行情况分析图
      initExecutionChart() {
        this.executionChart = echarts.init(document.getElementById('executionChart'))
        const option = {
          tooltip: {
            trigger: 'axis',
            axisPointer: {
              type: 'shadow'
            }
          },
          legend: {
            data: ['计划随访', '实际执行', '未执行']
          },
          grid: {
            left: '3%',
            right: '4%',
            bottom: '3%',
            containLabel: true
          },
          xAxis: {
            type: 'value'
          },
          yAxis: {
            type: 'category',
            data: ['呼吸科', '肿瘤科', '泌尿科', '心内科', '消化科']
          },
          series: [
            {
              name: '计划随访',
              type: 'bar',
              stack: '总量',
              label: {
                show: true
              },
              emphasis: {
                focus: 'series'
              },
              data: [120, 132, 101, 134, 90]
            },
            {
              name: '实际执行',
              type: 'bar',
              stack: '总量',
              label: {
                show: true,
                position: 'inside'
              },
              emphasis: {
                focus: 'series'
              },
              data: [110, 125, 95, 130, 85]
            },
            {
              name: '未执行',
              type: 'bar',
              stack: '总量',
              label: {
                show: true,
                position: 'inside'
              },
              emphasis: {
                focus: 'series'
              },
              data: [10, 7, 6, 4, 5]
            }
          ]
        }
        this.executionChart.setOption(option)
      },
      
      // 随访渠道分布图
      initChannelChart() {
        this.channelChart = echarts.init(document.getElementById('channelChart'))
        const option = {
          tooltip: {
            trigger: 'item',
            formatter: '{a} <br/>{b} : {c} ({d}%)'
          },
          legend: {
            orient: 'vertical',
            right: 10,
            top: 'center',
            data: ['电话随访', '微信随访', '线下门诊', '家访', '视频会诊']
          },
          series: [
            {
              name: '随访渠道',
              type: 'pie',
              radius: '65%',
              center: ['40%', '50%'],
              data: [
                { value: 45, name: '电话随访' },
                { value: 35, name: '微信随访' },
                { value: 15, name: '线下门诊' },
                { value: 3, name: '家访' },
                { value: 2, name: '视频会诊' }
              ],
              emphasis: {
                itemStyle: {
                  shadowBlur: 10,
                  shadowOffsetX: 0,
                  shadowColor: 'rgba(0, 0, 0, 0.5)'
                }
              }
            }
          ]
        }
        this.channelChart.setOption(option)
      },
      
      // 刷新图表
      refreshCharts() {
        this.completionRateChart.dispose()
        this.satisfactionChart.dispose()
        this.executionChart.dispose()
        this.channelChart.dispose()
        this.$nextTick(() => {
          this.initCharts()
        })
      },
      
      // 自适应大小
      resizeAllCharts() {
        this.completionRateChart && this.completionRateChart.resize()
        this.satisfactionChart && this.satisfactionChart.resize()
        this.executionChart && this.executionChart.resize()
        this.channelChart && this.channelChart.resize()
      },
      
      // 异常数据处理
      handleWarning(item) {
        this.$message.success(`开始处理异常数据：${item.content}`)
      },
      ignoreWarning(item) {
        this.warningData = this.warningData.filter(warning => warning.id !== item.id)
        this.$message.success(`已忽略异常数据`)
      },
      
      // 表格相关方法
      generateTableData() {
        this.tableData = []
        for (let i = 0; i < this.pageSize; i++) {
          const index = (this.currentPage - 1) * this.pageSize + i + 1
          const isCompleted = Math.random() > 0.15
          const planDate = this.randomDate('2024-01-01', '2024-12-31')
          const status = isCompleted ? '完成' : '未完成'
          const satisfaction = isCompleted ? Math.floor(Math.random() * 3) + 3 : 0
          
          this.tableData.push({
            id: `patient-${index}`,
            patientName: this.patientNames[Math.floor(Math.random() * this.patientNames.length)] + index,
            followUpType: this.followUpTypes[Math.floor(Math.random() * this.followUpTypes.length)],
            department: this.departments[Math.floor(Math.random() * this.departments.length)],
            doctor: this.doctors[Math.floor(Math.random() * this.doctors.length)],
            planDate,
            actualDate: isCompleted ? this.randomDate(planDate, '2024-12-31') : '-',
            status,
            satisfaction,
            detail: `这是患者${index}的随访详情，包含健康状况、用药情况和注意事项等内容。随访过程中，患者反馈${isCompleted ? '良好' : '存在一些问题'}。`,
            scaleResult: Math.floor(Math.random() * 40) + 60
          })
        }
      },
      
      handleExpandChange(row, expandedRows) {
        this.expandRowKeys = expandedRows.map(row => row.id)
      },
      
      viewDetail(row) {
        this.$message.info(`查看患者 ${row.patientName} 的详细信息`)
      },
      
      handleEdit(row) {
        this.$message.info(`编辑患者 ${row.patientName} 的随访记录`)
      },
      
      viewDocument(row) {
        this.$message.info(`查看患者 ${row.patientName} 的检查单`)
      },
      
      // 导出功能
      exportToExcel() {
        this.$message.success('正在导出Excel文件，请稍候...')
      },
      
      exportToPdf() {
        this.$message.success('正在导出PDF报告，请稍候...')
      },
      
      // 分页相关方法
      handleSizeChange(size) {
        this.pageSize = size
        this.generateTableData()
      },
      
      handleCurrentChange(page) {
        this.currentPage = page
        this.generateTableData()
      },
      
      // 辅助方法
      randomDate(start, end) {
        const startDate = new Date(start)
        const endDate = new Date(end)
        const randomDate = new Date(startDate.getTime() + Math.random() * (endDate.getTime() - startDate.getTime()))
        return `${randomDate.getFullYear()}-${String(randomDate.getMonth() + 1).padStart(2, '0')}-${String(randomDate.getDate()).padStart(2, '0')}`
      },
      
      customColorMethod(percentage) {
        if (percentage < 70) {
          return '#F56C6C'
        } else if (percentage < 85) {
          return '#E6A23C'
        } else {
          return '#67C23A'
        }
      }
    },
    beforeDestroy() {
      // 销毁图表实例和移除事件监听
      window.removeEventListener('resize', this.resizeAllCharts)
      this.completionRateChart && this.completionRateChart.dispose()
      this.satisfactionChart && this.satisfactionChart.dispose()
      this.executionChart && this.executionChart.dispose()
      this.channelChart && this.channelChart.dispose()
    }
  }
  </script>
  
  <style scoped>
  .dashboard-container {
    padding: 20px;
  }
  
  .filter-container {
    margin-bottom: 20px;
  }
  
  .filter-item {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
  }
  
  .dashboard-panel {
    margin-bottom: 20px;
  }
  
  .data-card {
    height: 100px;
    margin-bottom: 20px;
  }
  
  .card-item {
    display: flex;
    align-items: center;
  }
  
  .card-icon {
    width: 48px;
    height: 48px;
    border-radius: 8px;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-right: 12px;
  }
  
  .card-icon i {
    font-size: 24px;
    color: #fff;
  }
  
  .card-info {
    display: flex;
    flex-direction: column;
  }
  
  .card-title {
    font-size: 14px;
    color: #909399;
  }
  
  .card-count {
    font-size: 20px;
    font-weight: bold;
    margin-top: 5px;
  }
  
  .chart-container {
    margin-bottom: 20px;
  }
  
  .chart-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  
  .warning-container {
    margin-bottom: 20px;
  }
  
  .warning-header {
    color: #E6A23C;
    font-weight: bold;
  }
  
  .warning-item {
    padding: 10px 0;
    border-bottom: 1px solid #EBEEF5;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  
  .warning-text {
    flex: 1;
  }
  
  .warning-actions {
    display: flex;
    gap: 10px;
  }
  
  .table-container {
    margin-bottom: 20px;
  }
  
  .table-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  
  .right-btns {
    display: flex;
    gap: 10px;
  }
  
  .expanded-row {
    margin: 0;
    padding: 15px;
  }
  
  .pagination-container {
    margin-top: 20px;
    display: flex;
    justify-content: center;
  }
  </style>